import StrData from "../datafiles/stringmanagement_data.json";
import StrData_koen from "../datafiles/stringmanagement_en_data.json";
import React from "react";
import { getLocaleInfo } from "../Config";
import { Locale } from "./Types";
import { isEndWithConsonant } from "./ApiCommon";
// import { Text } from "react-native";

export const GetStringByKey = (key) => {
  let Strfile = null;
  switch (getLocaleInfo()) {
    case Locale.kokr:
      Strfile = StrData;
      break;
    case Locale.koen:
      Strfile = StrData_koen;
      break;
    default:
      break;
  }
  let str = "";
  if (Strfile !== null) {
    const findValue = Strfile.find((data) => data.STRING_ID === key);

    if (findValue !== undefined) {
      str = findValue.STRING;
    }
  }

  return str;
};

export const GetStringByKeyValues = (key, values) => {
  let originMsg = GetStringByKey(key);
  let msg = originMsg;

  if (msg !== null && values.length > 0) {
    for (let i = 0; i < values.length; i++) {
      const target = values[i].target;
      const value = values[i].value;

      msg = msg.replace(target, value);

      const hasConsonant = isEndWithConsonant(value ?? "");

      msg = msg?.replace(/을\/를|은\/는/g, (vl) => {
        switch (vl) {
          case "을/를":
            return hasConsonant ? "을" : "를";

          case "은/는":
            return hasConsonant ? "은" : "는";

          default:
            return vl;
        }
      });
    }
  }

  return msg;
};

export const GetStringByKeyOption = (key) => {
  let str = "";
  const findValue = StrData.find((data) => data.STRING_ID === key);
  if (findValue !== undefined) {
    let val = findValue.STRING.split("{C}");
    str = val[0];
    for (let i = 0; i < val.length; i++) { }

    str = (
      <>
        {" "}
        <span style={{}}>{str}</span>
        <span style={{ color: val[2] }}>{val[1]}</span>
      </>
    );

    console.log(val);
  }
  return str;
};

export const GetStringByKeyOptionTest = (key) => {
  // let Strfile = null;
  // switch (getLocaleInfo()) {
  //   case Locale.kokr:
  //     Strfile = StrData;
  //     break;
  //   case Locale.koen:
  //     Strfile = StrData_koen;
  //     break;
  //   default:
  //     break;
  // }
  // let str = "";
  // if (Strfile !== null) {
  //   const findValue = Strfile.find((data) => data.STRING_ID === key);

  //   if (findValue !== undefined) {
  //     str = findValue.STRING;

  //     let text = findValue.STRING.match(/\<b>.*\<\/b>/gi);
  //     text += "";

  //     text = text.split("<b>").join("");
  //     text = text.split("</b>").join("");
  //     console.log(text);



  //     str = ㅇㅇ + `${<Text style={{ fontWeight: "bold", color: "#4040cc" }}>{text}</Text>}`

  //     // console.log(str.props);

  //   }
  // }

  // return str;
};
